import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _RequestCredit, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { MASK_MONEY } from "../../../../theme/Component/BasicTable";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { CreditDetails } from "./Components/CreditDetails";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { Modal } from "../../../../theme/Component/Modal";
import useModal, { MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { CreditDetailsRef } from "./Components/CreditDetailsRef";
import { SelectCreditRoleGroup } from "../../../../erp/CreditRoleGroup/SelectCreditRoleGroup";
import { InputMoney } from "../../../../theme/Input/InputMoney";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Approve: string;
    ApproveValue: number;
    CuotasApprove: number;
}

export const CC005 = ({ configProcedure }: Props) => {
    const { instance, bean, setBean } = useDataBean(_RequestCredit);

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: "",
        ApproveValue: null,
        CuotasApprove: null
    })

    const [props, setProps] = useState<any>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
        getReuqest();
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        instance.updateRequestCredit({
            ...bean,
            AmountApprove: response.ApproveValue,
            Cuotes: response.CuotasApprove,
        })

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(response.Obs)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ ObsAnalist: response.Obs, ApproveReferencer: response.Approve })
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }

    }

    useEffect(() => {
        if (response.Approve !== "") {
            onExportMap();
        }
    }, [response]);

    const updateForm = (app: string) => {
        setResponse(prev => ({ ...prev, Approve: app }));
    }

    const getReuqest = () => {
        const props = {
            IDProcedureImp: configProcedure._procedure.IDProcedureImp
        }
        instance.getRequestCreditCatalogPorPropiedades(props, null).then(
            (resp) => {
                const x = resp[0].DataBeanProperties;
                setBean(x)
                setResponse({ ...response, ApproveValue: x.AmountApprove, CuotasApprove: x.Cuotes })
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const isChecklistValid = (jsonCheckList: any) => {
        if (!jsonCheckList || jsonCheckList === "") return false;

        try {
            const parsed = typeof jsonCheckList === "string" ? JSON.parse(jsonCheckList) : jsonCheckList;

            const requiredProps = ["Location", "LocationCodeudor", "Reference", "RederenceCodeudor"];

            // Verifica si alguna de las propiedades requeridas existe y es true
            // const hasRequiredValidations = requiredProps.some(prop => parsed.hasOwnProperty(prop) && parsed[prop] === true);
            const hasRequiredValidations = requiredProps.some(prop => parsed.hasOwnProperty(prop));

            return hasRequiredValidations;
        } catch (e) {
            return false;
        }
    };


    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-4">
                    <label>Cuotas Aprobadas</label>
                    <input type="number" className="form-control" value={response.CuotasApprove} onChange={(e) => { setResponse({ ...response, CuotasApprove: parseInt(e.target.value) }) }} />
                </div>
                <div className="col-md-4 mb-2">
                    <InputMoney _label="Valor Aprobado" _value={response.ApproveValue} onChange={(e) => { setResponse({ ...response, ApproveValue: e }) }} />
                </div>
                <div className="col-md-12 mb-2">
                    <label>Observaciones</label>
                    <textarea rows={6} className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-12">
                    <div className="col-md-12 mt-3">
                        <CreditDetailsRef
                            objectUpdate={bean}
                            onUpdate={() => { getReuqest(); }}
                            pushInfo={(e) => { configProcedure?._pushInfo(e) }}
                            Props={{
                                Codeudor: bean.JSONCodeuda ? JSON.parse(bean.JSONCodeuda) : {},
                                Credito: bean.JSONCredit ? JSON.parse(bean.JSONCredit) : {},
                                Notas: bean.JSONNotes ? JSON.parse(bean.JSONNotes) : {},
                                CheckList: bean.JSONCheckList ? JSON.parse(bean.JSONCheckList) : {},
                                JSONDeudor: bean.JSONDeudor ? JSON.parse(bean.JSONDeudor) : {},
                                RProps: props
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <BasicButton disable={!isChecklistValid(bean.JSONCheckList)} icon="ri-checkbox-circle-line" eventClick={() => { updateForm("true") }} >Enviar</BasicButton>
                </div>
                <div className="col-md-4 d-flex justify-content-end position-relative">
                    <div className="btn-group" role="group">
                        <button
                            id="btnGroupReject"
                            type="button"
                            className="btn btn-danger dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={!isChecklistValid(bean.JSONCheckList)}
                        >
                            Rechazar
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="btnGroupReject">
                            <li>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        updateForm("false");
                                    }}
                                >
                                    Archivar
                                </a>
                            </li>
                            <li>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        updateForm("Return");
                                    }}
                                >
                                    Devolver Analista
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};